/* ========================== */  
/* ========= import ========= */  
/* ========================== */  

/* ====== React ====== */
// import React from "react"
/* ====== CSS ====== */
import styled from 'styled-components';
/* ====== Component Js/Jsx ====== */
import { InputErrorMessage } from '02CommonUiParts/TableParts/InputErrorMessage';
import { assets } from '03CommonApiParts/Configuration';
/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
const SdivInputGroup = styled.div` //インプットのグループ
    display:flex;
    align-items: center;
`;
const SdivInputGroupB = styled.div` //インプットのグループ
    height: ${props => props.inputGroupHeight ? props.inputGroupHeight : ''};
    align-items: center;
    /* display: flex; */
`;
const SdivInputTileLabel = styled.div`//入力項目のタイトル
    white-space: nowrap;
    display: flex;
    align-items: center;

`;
const Sinput = styled.input` //入力欄
    height:28px;
    width: ${props => props.type === 'search' ? '100%' : 'calc(100% - 12px)'};
    padding:0 5px;
    margin: 2px 0;
    border-radius:3px;
    border: ${props => props.readOnly ? 'transparent' : '1px solid #C0C0C0'};
    background-color:${props => props.readOnly ? 'transparent' : props.isDirty ? assets().color.lightYellow : 'white'};
    &:focus{
        outline: solid 1.5px ${assets().color.focusOutline};
    }
    &:disabled{
        color:black;
        opacity:1;
        background-color:${props => props.readOnly ? 'red' : assets().color.disabled};
        border:${assets().color.disabled};
    }
    &:disabled&::placeholder{
        color: transparent;
    }
    &:read-only{
        outline: none;
        cursor: inherit;
    };
    &:read-only&::placeholder{
        color: transparent;
    };
    
`;
const Slabel = styled.label` //ラベル表示
    margin:0 0 0 6px;
    height:32px;
    display:flex;
    align-items: center;
`;

/* ========================== */  
/* ==== leftTitleテーブル用 === */  
/* ========================== */  
/* ------　エラー右に表示　------ */
export const LeftTitleTableInputField = (props) => {
/* ========================== */  
/* ========== variables ========== */  
/* ========================== */  
    const { title, placeholder, register, maxLength, width, disabled, rightLabel, type , errorMessage, readOnly, isDirty} = props;
    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */
    return (
            <SdivInputGroup >
                    {title?<SdivInputTileLabel className='baseText' style={{fontSize:assets().size.baseText}}>{title}</SdivInputTileLabel>:<></>}
                    <Sinput 
                        isDirty={isDirty}
                        {...register} 
                        autoComplete='off'
                        maxLength={maxLength}
                        disabled={disabled}
                        readOnly={readOnly}
                        style={{fontSize:assets().size.baseText,height:assets().size.inputHeight,width:width}}
                        placeholder={placeholder}
                        type={type}
                        className='inputText'
                    />
                    <Slabel className='baseText'style={{fontSize:assets().size.baseText}}>{rightLabel}</Slabel>
                    {errorMessage ? <InputErrorMessage errorMessage={errorMessage}/> : ''}
            </SdivInputGroup>
    );
};

/* ========================== */  
/* === table用inputField ==== */  
/* ========================== */  
export const TableInputField = (props) => {
/* ========================== */  
/* ========== variables ========== */  
/* ========================== */  
    const { placeholder, register, maxLength, disabled, align, type , errorMessage, readOnly,inputGroupHeight,boxStyle, isDirty} = props;
    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */
    return (
            <SdivInputGroupB inputGroupHeight={inputGroupHeight} style={boxStyle}>
                <Sinput  
                    isDirty={isDirty}
                    {...register} 
                    autoComplete='off'
                    maxLength={maxLength}
                    disabled={disabled}
                    readOnly={readOnly}
                    style={{fontSize:assets().size.baseText,height:assets().size.inputHeight,textAlign:align}}
                    placeholder={placeholder}
                    type={type}
                    className='inputText'
                />
                {errorMessage ? <InputErrorMessage errorMessage={errorMessage}/> : ''}
            </SdivInputGroupB>
    );
};